import { createAPI } from '../../composable/useAPI';
import Login from '../../pages/Login/Login';


export const useUserAPI = () => {

  const api = createAPI();

  const request = {
    loginOut: async () => {
      try {
        const response = await api.post('/api/v2/session/logout', null, {
          withCredentials: true,
        });
        return response.data;
      } catch (error) {
        console.error('Logout request failed : ', error);
        throw error;
      }
    },
    login: async (params) => {
      try {
        const formData = new FormData();
        formData.append('username', params.username);
        formData.append('password', params.password);

        const response = await api.post('/login', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          withCredentials: true,
        });
        return response.data;
      } catch (error) {
        console.error('Login request failed:', error);
        throw error;
      }
    },
    user : {
      findByCompanySeq: async (params) => {
        try {
          const response = await api.get('/api/v2/user/findByCompanySeq', { params });
          return response.data.data;
        } catch (error) {
          console.error('GET request failed:', error);
          throw error;
        }
      },
    }
  };

  return {
    ...request
  }
}
